/**
 * @param {function} fn
 * @returns {function}
 */
function map(fn) {
  return function (combine) {
    return function (result, x) {
      return combine(result, fn(x));
    };
  };
}

export default map;


// WEBPACK FOOTER //
// ./node_modules/lyjs/es/fp/map.js